import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NumericRangeComponent } from './numeric-range.component'
import { InputTextModule } from 'primeng/inputtext'
import { FormsModule } from '@angular/forms'

@NgModule({
  declarations: [NumericRangeComponent],
  imports: [CommonModule, InputTextModule, FormsModule],
  exports: [NumericRangeComponent],
})
export class NumericRangeModule {}
